<div id="pcoded" class="pcoded">
    <div class="pcoded-overlay-box"></div>
    <div class="pcoded-container navbar-wrapper">
      <app-header></app-header>
      <div class="pcoded-main-container">
        <div class="pcoded-wrapper">
          <div class="pcoded-content">
            <div class="pcoded-inner-content">
              <div class="">
                <div class="page-wrapper">
                  <div class="page-header">
                  </div>
                  <div class="page-body">
                    <div class="container-fluid">
                      <router-outlet></router-outlet>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>